import { Loader } from 'lucide-react';

export const LoadingSpinner = () => (
  <div className='flex h-8 w-8 items-center justify-center' role='status' aria-label='Loading'>
    <Loader className='h-5 w-5 animate-spin stroke-blue-500 drop-shadow-[0_0_6px_rgba(59,130,246,0.8)]' />
    <span className='sr-only'>Loading...</span>
  </div>
);
